module.exports = __webpack_public_path__ + "img/t2-salmon.09253007.png";